// extracted by mini-css-extract-plugin
export default {"secondary":"secondary_button-module__secondary--3uVY-"};